import { HoldingClass, StockPlan } from 'types';

type ExportTableProps = {
  button: string;
  updatedPartners: any[];
  selectedPartners: any[];
  plans: StockPlan[];
  holdingClasses: HoldingClass[];
};

const buttons = {
  equity: 'equityBtn',
  summary: 'summaryBtn',
  original: 'tableBtn',
};

export const exportTable = ({
  button,
  updatedPartners,
  selectedPartners,
  plans,
  holdingClasses,
}: ExportTableProps) => {
  const btn = document.getElementById(button);

  if (!btn) {
    return;
  }

  const canDownloadEquity = updatedPartners.length > 0;
  const canDownloadSummary =
    selectedPartners.length > 0 && plans && holdingClasses.length > 0;

  if (button === buttons.equity && canDownloadEquity) {
    btn.click();
    return;
  }

  if (button === buttons.summary && canDownloadSummary) {
    btn.click();
    return;
  }

  if (button === buttons.original) {
    btn.click();
  }
};
